const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/route.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/adaptive-planner/plan/$planId/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
export const Route = createFileRoute('/(app)/org/$org/adaptive-planner/plan/$planId')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  pendingComponent: FullSizeSpinner,
  loader: async ({
    context: {
      queryClient
    },
    params: {
      planId
    }
  }) => {
    const planNum = Number(planId);
    await queryClient.ensureQueryData(getPlanQueryOptions({
      planId: planNum
    }));
  },
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});